// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/compliance/modals/shared/TaskQueueCard.jsx

import React from "react";
import {
  ActionGroup,
  Card,
  StatusChip,
} from "../../../../design-system/components";

function normalizeTone(tone) {
  const value = String(tone || "").trim().toLowerCase();

  if (["ok", "healthy", "passed", "complete"].includes(value)) {
    return "success";
  }
  if (["warn", "attention", "pending"].includes(value)) {
    return "warning";
  }
  if (["danger", "error", "critical", "failed"].includes(value)) {
    return "danger";
  }
  if (["info", "informational", "default"].includes(value)) {
    return "informational";
  }
  return "neutral";
}

export default function TaskQueueCard({
  title,
  chips = [],
  dueLabel = "No due date",
  meta = [],
  context,
  contextLabel = "Context",
  actions = [],
}) {
  return (
    <Card
      as="article"
      tone="secondary"
      density="default"
      className="oasys-task-queue-card"
    >
      <div className="oasys-task-queue-card__top">
        <div className="oasys-task-queue-card__chips">
          {(Array.isArray(chips) ? chips : [])
            .filter(Boolean)
            .map((chip) => (
              <StatusChip
                key={`${chip.label}-${chip.tone || "default"}`}
                tone={normalizeTone(chip.tone)}
              >
                {chip.label}
              </StatusChip>
            ))}
        </div>

        <span className="oasys-task-queue-card__due">
          {dueLabel}
        </span>
      </div>

      <h4 className="oasys-task-queue-card__title">{title}</h4>

      {meta.length > 0 ? (
        <dl className="oasys-task-queue-card__meta">
          {meta.map((item) => (
            <div
              key={item.label}
              className={
                item.wrap
                  ? "oasys-task-queue-card__meta-item oasys-wrap-anywhere"
                  : "oasys-task-queue-card__meta-item"
              }
            >
              <dt>{item.label}</dt>
              <dd>{item.value}</dd>
            </div>
          ))}
        </dl>
      ) : null}

      {context ? (
        <div className="oasys-task-queue-card__context">
          <span>{contextLabel}</span>
          <p>{context}</p>
        </div>
      ) : null}

      <ActionGroup actions={actions} density="compact" />
    </Card>
  );
}
